import React from 'react'
import { alertIcon, ids, docExampleMobile } from '../../assets/images/images'

const Step1InfoText = () => {
  return (
    <div className="backgroundDefault py15 mb3">
      <div className="dFlex alignItemsStart mb15 md-fontSizeDefault">
        <img src={alertIcon} alt="QuestionIcon" className="mr1" />
        Veuillez vous assurer que toutes vos pièces justificatives sont valides
        et lisibles :
      </div>
      <img src={ids} alt="ids-icon" className="img-fluid hidden-on-mobile" />
      <img
        src={docExampleMobile}
        alt="ids-icon"
        className="img-fluid hidden-sm-up"
      />
    </div>
  )
}

export default Step1InfoText
